import {
  AddCircle,
  BorderColor,
  Description,
  DocumentScanner,
  ExpandMore,
  LocalPrintshop,
  MoreVert,
  Print,
  Save,
  Search,
  Visibility,
} from "@mui/icons-material";
import {
  Box,
  Chip,
  Grid,
  IconButton,
  Menu,
  Pagination,
  TextField,
  Typography,
} from "@mui/material";
import CarService from "_api/Car/buyCar";
import Actions from "components/Car/Actions";
import TableData from "components/Car/Table";
import ChipCustomize from "components/Chip";
import CustomizeDatePicker from "components/DatePicker";
import {
  GradientButton,
  GradientButtonOutline,
} from "components/GradientButton";
import ModalCreateTransferAndReceiptBuy from "components/Modal/Car/FormDocuments/TransferAndReceiptBuy";
import ModalBuyCar from "components/Modal/Car/ModalBuyCar";
import ModalDetailCar from "components/Modal/Car/ModalDetailCar";
import CustomPagination from "components/TableExplanded/Pagination";
import { filter, set } from "lodash";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { formatDateTime } from "utils/helpers/format";
import SearchBar from "components/TableExplanded/SearchBar";
import useApi from "_api/index";

const AllCars = () => {
  const [carsList, setCarsList] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 1,
  });
  const [filter, setFilter] = useState({
    search: "",
    searchIdCard: "",
    searchName: "",
    searchDate: "",
  });

  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchDate, setSearchDate] = useState("");
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    // Fetch data when the component mounts
    fetchData();
  }, [pagination.page, pagination.limit]);

  const fetchData = async (isClear = false) => {
    setLoading(true);
    try {
      // Simulate fetching data
      const response = await useApi.list_by_customer_car.getListByCustomerCar({
        page: pagination.page || 1,
        limit: pagination.limit || 10,
        ...(!isClear && filter),
      });
      const formatData =
        response.data?.map((item) => ({
          ...item,
          ...item.car,
          ...item.customer,
        })) || [];
      setCarsList(formatData);
      setPagination(response.meta);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    if (pagination.page !== 1) {
      setPagination((prev) => ({
        ...prev,
        page: 1, // Reset to first page when searching
      }));
    } else {
      fetchData();
    }
  };

  const handleClearSearch = async () => {
    setFilter({
      search: "",
      searchIdCard: "",
      searchName: "",
      searchDate: "",
    });
    if (pagination.page !== 1) {
      setPagination((prev) => ({
        ...prev,
        page: 1, // Reset to first page when clearing search
      }));
    } else {
      fetchData(true);
    }
  };

  const handleCreateModalClose = () => {
    setIsCreateModalOpen(false);
    if (isEditMode) {
      setIsEditMode(false); // Reset edit mode when closing the modal
      setSelectedRow(null); // Clear selected row when closing
    }
  };

  const handlePageChange = (event, value) => {
    setPagination((prev) => ({
      ...prev,
      page: value + 1,
    }));
  };
  const handleRowsPerPageChange = (event) => {
    setPagination((prev) => ({
      ...prev,
      limit: event.target.value,
      page: 1, // Reset to first page when changing rows per page
    }));
  };

  const handleRowClick = (row, type = "detail") => {
    setSelectedRow(row);
    if (type === "detail") {
      // Handle row click for detail view
      console.log("Row clicked for detail:", row);
      setIsDetailModalOpen(true);
    } else if (type === "edit") {
      // Handle row click for edit view
      console.log("Row clicked for edit:", row);
      setIsEditMode(true);
      setIsCreateModalOpen(true); // Open the detail modal in edit mode
    }
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography component={"div"} sx={{ fontSize: "32px" }}>
          รถทั้งหมด
        </Typography>
      </Box>
      <Grid
        container
        spacing={2}
        sx={{
          mb: 2,
        }}
      >
        <Grid item xs={12} md={6} lg={4}>
          <Grid container spacing={2} alignItems="center">
            <Grid
              item
              xs={3}
              sx={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Typography>รหัสรายการ</Typography>
            </Grid>
            <Grid item xs={9}>
              <TextField
                fullWidth
                variant="outlined"
                size="small"
                value={filter.search}
                onChange={(event) =>
                  setFilter((prev) => ({
                    ...prev,
                    search: event.target.value,
                  }))
                }
                sx={{
                  "& .MuiOutlinedInput-root": {
                    bgcolor: "white",
                    height: "40px",
                  },
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <Grid container spacing={2} alignItems="center">
            <Grid
              item
              xs={4}
              sx={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Typography>เลขบัตรประชาชน</Typography>
            </Grid>
            <Grid item xs={8}>
              <TextField
                fullWidth
                variant="outlined"
                size="small"
                value={filter.searchIdCard}
                onChange={(event) =>
                  setFilter((prev) => ({
                    ...prev,
                    searchIdCard: event.target.value,
                  }))
                }
                sx={{
                  "& .MuiOutlinedInput-root": {
                    bgcolor: "white",
                    height: "40px",
                  },
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <Grid container spacing={2} alignItems="center">
            <Grid
              item
              xs={3}
              sx={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Typography>ชื่อ - สกุล</Typography>
            </Grid>
            <Grid item xs={8}>
              <TextField
                fullWidth
                variant="outlined"
                size="small"
                value={filter.searchName}
                onChange={(event) =>
                  setFilter((prev) => ({
                    ...prev,
                    searchName: event.target.value,
                  }))
                }
                sx={{
                  "& .MuiOutlinedInput-root": {
                    bgcolor: "white",
                    height: "40px",
                  },
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <Grid container spacing={2} alignItems="center">
            <Grid
              item
              xs={3}
              sx={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <Typography
                  sx={{
                    fontSize: "16px",
                    whiteSpace: "nowrap",
                  }}
                >
                  วันที่:
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={9}>
              <CustomizeDatePicker
                value={filter.searchDate}
                onChange={(newValue) => {
                  setFilter((prev) => ({
                    ...prev,
                    searchDate: newValue,
                  }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        bgcolor: "white",
                        height: "40px",
                      },
                    }}
                  />
                )}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* searchQuery component can be added here if needed */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 2,
          justifyContent: "flex-end",
          mb: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 2,
            alignItems: "center",
          }}
        >
          <GradientButtonOutline
            onClick={() => {
              // Handle clear action
              handleClearSearch();
            }}
            sx={{
              height: "40px",
            }}
          >
            ล้าง
          </GradientButtonOutline>
          <GradientButton
            onClick={() => {
              // Handle search action
              handleSearch();
            }}
            endIcon={<Search />}
          >
            ค้นหา
          </GradientButton>
        </Box>
      </Box>

      {/* Table or list to display the cars */}
      <TableData
        loading={loading}
        data={carsList}
        columns={[
          {
            key: "expand",
            label: "",
            style: {
              textAlign: "center",
            },
          },
          {
            key: "car_picture",
            label: "รูปภาพ",
          },
          { key: "order_code", label: "รหัสรายการ" },
          { key: "car_type", label: "ประเภทรถ" },
          { key: "license_plate", label: "ทะเบียน" },
          { key: "car_brand", label: "ยี่ห้อ" },
          { key: "car_model", label: "รุ่น" },
          {
            key: "created_at",
            label: "วันที่ทำรายการ",
            render: (row) => formatDateTime(row.created_at),
          },
          {
            key: "status_name",
            label: "สถานะ",
            render: (row) => {
              return (
                <ChipCustomize
                  label={row.status_name}
                  status={row.status_name}
                />
              );
            },
          },
          {
            key: "action",
            label: "Actions",
            style: {
              textAlign: "center",
            },
            render: (row) => (
              <Actions
                menuList={[
                  {
                    label: "ดูรายละเอียด",
                    icon: <Visibility />,
                    onClick: () => {
                      handleRowClick(row, "detail");
                    },
                  },
                  {
                    label: "พิมพ์ QR Code",
                    icon: <LocalPrintshop />,
                    onClick: () => {
                      console.log("Print clicked for row:", row);
                    },
                  },
                ]}
              />
            ),
          },
        ]}
      />

      <CustomPagination
        totalPage={pagination.totalPages}
        onPageChange={(event, value) => {
          handlePageChange(event, value);
        }}
        page={pagination.page - 1}
        rowsPerPage={pagination.limit}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      <ModalBuyCar
        open={isCreateModalOpen}
        onClose={handleCreateModalClose}
        onSaved={() => {
          fetchData(1, pagination.limit); // Refresh the data after saving
        }}
        isEdit={isEditMode}
        id={selectedRow ? selectedRow.car_id : null}
      />

      <ModalDetailCar
        open={isDetailModalOpen}
        onClose={() => {
          setIsDetailModalOpen(false);
          setSelectedRow(null); // Clear selected row when closing
        }}
        rowID={selectedRow ? selectedRow.car_id : null}
        type="list_by_customer_car"
        formlist={[
          {
            id: 1,
            document: "แบบคำขอโอนและรับโอน",
            document_type: "car_transform",
          },
          {
            id: 2,
            document: "หนังสือมอบอำนาจ",
            document_type: "car_power_of_attorney",
          },
          {
            id: 3,
            document: "หนังสือสัญญาซื้อ - ขายรถ",
            document_type: "car_buy_sell_contract",
          },
        ]}
      />
    </Box>
  );
};

export default AllCars;
